import * as React from 'react';
import LoadingButton from '@mui/lab/LoadingButton';
import Bs4GenericField from './Bs4GenericField';
import Bs4MainDispatch from '../../Bs4MainDispatch';
import {PLAYER_LOADED_CHANGE, bs4VarianticPlayer} from './Bs4Variantic'
import {Bs4Icon, getBs4Icon} from '../../Bs4Components/Bs4Icon'
import * as Bs4Utils from '../../Bs4Components/Bs4Utils';

export default class Bs4SaveVar extends Bs4GenericField {  

  uploadNewFiles = (files) => {
    if (!Array.isArray(files)) return;
    if (!files.length) return;
    const formData = new FormData();    
    files.forEach((file, index) => {
      formData.append(this.props.field.formId + '_file_' + file.name, file);
    });

    const fields = this.bs4Form.gatherFormValues();
    const details = { 
      currFormId: this.props.field.formId,
      formData: fields.fieldsDict,
      currCardViewId: this.bs4KartotekaId, 	
      currOptionId: this.optionId,
    };

    formData.append('allparams', JSON.stringify(Bs4MainDispatch.getParserParams(details, this.bs4KartotekaId)));

    fetch(Bs4MainDispatch.getUrlPath('web.php?com=Bs4UploadFile'), {method: 'POST', body: formData})
    .then(response => response.text())
    .then(returnedText => {
      try {
        const returnedJson = JSON.parse(returnedText);
        Bs4MainDispatch.parsingBs4Response(returnedJson, this.bs4KartotekaId);
      } catch (e) {
        console.log(e);
        console.log(returnedText);
      }
    })
    .catch((error) => {
      console.log(error);
    })
  }

  uploadNewFile = (file) => {
    const formData = new FormData();

    formData.append(this.props.field.formId + '_file_' + file.name, file);
    const fields = this.bs4Form.gatherFormValues();
    const details = {
      currFormId: this.props.field.formId,
      formData: fields.fieldsDict,
      currCardViewId: this.bs4KartotekaId, 	
      currOptionId: this.optionId,
    };

    formData.append('allparams', JSON.stringify(Bs4MainDispatch.getParserParams(details, this.bs4KartotekaId)));

    fetch(Bs4MainDispatch.getUrlPath('web.php?com=Bs4UploadFile'), {method: 'POST', body: formData})
    .then(response => response.text())
    .then(returnedText => {
      try {
        const returnedJson = JSON.parse(returnedText);
        Bs4MainDispatch.parsingBs4Response(returnedJson, this.bs4KartotekaId);
        // console.log('...Bs4SaveVar...uploadNewFile...', returnedJson)
      } catch (e) {
        console.log(e);
        console.log(returnedText);
      }
    })
    .catch((error) => {
      console.log(error);
    })
  }

  ViewComponentField = (props) => {
    const formField = this;
    const [varianticPlayer, setVarianticPlayer] = React.useState(bs4VarianticPlayer.node);
    const [loading, setLoading] = React.useState(false);

    this.refFocus = React.useRef();

    React.useEffect(() => {
      const playerLoadedChange = () => {
        console.log('...Bs4Variantic...playerLoaded...Bs4SaveVar', bs4VarianticPlayer);
        setVarianticPlayer(bs4VarianticPlayer.playerLoaded ? bs4VarianticPlayer.node : null)
      }

      bs4VarianticPlayer.eventEmit.on(PLAYER_LOADED_CHANGE, playerLoadedChange);

      return () => {
        bs4VarianticPlayer.eventEmit.off(PLAYER_LOADED_CHANGE, playerLoadedChange);
        setVarianticPlayer(null)
      }
    }, [setVarianticPlayer])

    // saveConfig
    // saveBom
    // savePicture
    // getPDF
    

    // com=bs4UploadFile - Gdy wybrano getPDF:1. Akcja taka sama jak w kontrolce bs4File, ale przesyła tylko 1 plik i jest to plik pdf uzyskany z variantic poleceniem generującym wizualizację po stronie frontend. Wysyłamy poza plikiem stałe elementy określające ID elementu formularza. Serwer rozpozna, że to element formularz variantic i sobie odpowiednio powiąże plik. Plik musi mieć nazwę z końcówką pdf
    // com=bs4SaveCad (nowa, gry wybrano saveConfig :1). Akcja ma wysyłać poza id elementu formularza, atrybuty: configurationJson (uzyskany json z opisem projektu z variantic), configurationId (uzyskane id z zapisu projektu saveConfig w Variantic).
    console.log('...Bs4SaveVar...', this.getValue());

    const saveConfig = (collector) => {
      if (this.getValue().saveConfig === 1) {
        varianticPlayer.saveConfiguration()
        .then(configurationStr => {
          collector.configuration = JSON.parse(configurationStr)
          collector.configurationJson = configurationStr;
          collector.configurationId = collector.configuration.id;          
          saveBom(collector);
        })
        .catch(error => {
          console.log('...Bs4Variantic...error saveConfiguration', error);
          saveBom(collector);
        })
      } else {
        saveBom(collector);
      }
    } 

    const saveBom = (collector) => {
      const saveConfigs = this.getValue().saveBom
      console.log('...saveConfigs...', saveConfigs);
      if (Array.isArray(saveConfigs)) {
        const promises = [];

        saveConfigs.forEach((bom, index) => {
          promises.push(varianticPlayer.player.bom.getBom(bom.varianticTemplateId, bom.varianticFilterId));
        })
        
        Promise.all(promises)
        .then(values => {
          collector.configurationJson = {}
          values.forEach((value, index) => {
            const bom = saveConfigs[index];
            collector.configurationJson[bom.bs4VariableKey] = value.body;
          })          
          handleClickButtonEnd(collector);
        })
        .catch(values => {
          console.log('...bom...promises...catch...', values);
          handleClickButtonEnd(collector);
        })
      } else {
        handleClickButtonEnd(collector);
      }
    } 


    const savePicture = (collector) => {
      if (parseInt(this.getValue().savePicture) === 1) {
        try{
          varianticPlayer.takeASnapshot()
          .then(response => {
            console.log('...Bs4Variantic...takeASnapshot 1', response);  
            const filename = response.url.split('/').pop();
            fetch(response.url)
            .then(res => res.blob())
            .then(blob => {
              const file = new File([blob], filename, {type: blob.type, lastModified: new Date().getTime()});
              console.log('...fetch.2.', file);
              collector.files.push(file);
              saveConfig(collector);
            })
            .catch(error => {
              console.log('...openNewDownload fetch catch', error);
              saveConfig(collector);
            })                                 
          })
          .catch((error) => {
            console.log('...Bs4Variantic...takeASnapshot catch', error);  
            saveConfig(collector);
          });
        } catch(error) {
          console.log('...Bs4Variantic...takeASnapshot catch error', error);  
          saveConfig(collector);
        }        
      } else {
        saveConfig(collector);
      }
    } 

    const getPDF = (collector, iteration = 0) => {
      if (this.getValue().getPDF === 1) {
        try{
          //if() sprawdza czy dane do modułu dokumentacji zostały pobrane
          //jeśli nie - wywołuję funkcję przez mediator aby plik został wygenerowany za pierwszym kliknięciem
          if(!varianticPlayer.player.documentation){
            varianticPlayer.player.mediator.generateDocumentation(false)
            .then((blob) => {
              console.log('...Bs4Variantic...generateDocumentatio then', blob);  
              const name = 'Bs4SaveVar'+Bs4Utils.toDateTimeName(new Date());
              const file = new File([blob], name+'.pdf', {type: blob.type, lastModified: new Date().getTime()});
              console.log('...Bs4Variantic...generateDocumentatio then file', file);
              collector.files.push(file);
              savePicture(collector);
            })
            .catch((error, a, b) => {
              console.log('...Bs4Variantic...generateDocumentatio catch', error);  
              if (iteration === 0) getPDF(collector, iteration+ 1 );
              else savePicture(collector);
            })              
          } else {
            varianticPlayer.player.setLayoutMediator.generateDocumentation(false)			
            .then((blob) => {
              console.log('...Bs4Variantic...generateDocumentatio then', blob);  
              const name = 'Bs4SaveVar'+Bs4Utils.toDateTimeName(new Date());
              const file = new File([blob], name+'.pdf', {type: blob.type, lastModified: new Date().getTime()});
              console.log('...Bs4Variantic...generateDocumentatio then file', file);
              collector.files.push(file);
              savePicture(collector);
            })
            .catch((error, a, b) => {
              console.log('...Bs4Variantic...generateDocumentatio catch', error);  
              if (iteration === 0) getPDF(collector, iteration+ 1 );
              else savePicture(collector);
            })
          }
        } catch(error) {
          console.log('...Bs4Variantic...generateDocumentatio catch error', error);  
          if (iteration === 0) getPDF(collector, iteration+ 1 );
          else savePicture(collector);
        }        
      } else {
        savePicture(collector);
      }
    }

    const handleClickButtonStart = (e) => {      
      console.log('...Bs4SaveVar...handleClickButtonStart...', this.getValue());
      setLoading(true);

      const collector = {files: []}
      if (parseInt(this.getValue().getPrice) === 1) {
        try {
        collector.VarianticPrice = varianticPlayer.player.mediator.getPrice()
        } catch(error) {
          console.log('...Bs4Variantic...getPrice catch', error);  
        }
      }

      getPDF(collector);
    }

    const handleClickButtonEnd = (collector) => {      
      console.log('...Bs4SaveVar...handleClickButtonEnd...', collector);
      this.uploadNewFiles(collector.files);
      
      const details = this.bs4Form.getDetails(this.props.field.formId);
      details.inputId = this.props.field.inputId;
      if (collector.VarianticPrice) details.VarianticPrice = collector.VarianticPrice;
      if (collector.configurationId) details.configurationId = collector.configurationId;
      if (collector.configurationJson) details.configurationJson = collector.configurationJson; // bom
      Bs4MainDispatch.commandParser('bs4SaveCad', details, this.bs4KartotekaId);

      setLoading(false);
    }
      
    return (      
      <LoadingButton  
        ref={this.refFocus}
        sx={{my:0.5}} 
        onClick={handleClickButtonStart} 
        startIcon={getBs4Icon({iconCls: this.props.field?.iconCls, iconStyle: this.props.field?.iconStyle})}
        disabled={this.readOnly || !varianticPlayer}
        loading={loading}
      >
        <div dangerouslySetInnerHTML={{__html:this.getLabelPlane()}}/>
      </LoadingButton>
    )   
  }
}